<template>
  <SelectMiniColored
    v-if="mini"
    v-model="selectedValues"
    :options="options"
    :disabled="disabled"
  />
  <SelectComponent
    v-else
    v-model="selectedValues"
    name="status_task"
    :values="options"
    colored
    :edition-mode="!disabled"
    track-by="value"
    :label="$t('attributes.status')"
  />
</template>

<script>
import SelectMiniColored from '@c/SelectMiniColored'
import { computed } from 'vue'
import { mapGetters } from 'vuex'
import SelectComponent from '@c/BaseFormComponent/SelectComponent.vue'

export default {
  name: 'SelectMiniStatusTask',
  components: { SelectComponent, SelectMiniColored },
  props: {
    modelValue: {
      type: [String, Number],
      required: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    mini: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  emits: ['update:modelValue', 'valueChanged'],
  setup(props, { emit }) {
    const selectedValues = computed({
      get: () => props.modelValue,
      set: (value) => {
        emit('valueChanged', value)
        emit('update:modelValue', value)
      }
    })
    return { selectedValues }
  },
  computed: {
    ...mapGetters({
      task_statuses: 'metadata/getMetadataTaskStatuses'
    }),
    options() {
      if (!this.task_statuses) return []
      return this.task_statuses.reduce((array, item) => {
        array.push({
          value: item.id,
          bg_color: item.bg_color,
          icon: item.icon,
          name: this.$t('enums.task.status.' + item.id)
        })
        return array
      }, [])
    }
  }
}
</script>
